export const ticketReadonlyThresholdDays = 90;
export const testFeedbackTitlePrefix = "vsftest ";
